import { DurationType } from './OrbitalInsights'
import { mergeClassNames } from '../../../utils/commonFunctions'

interface DurationToggleButtonProps {
    durationType: DurationType
    setDurationType: (durationType: DurationType) => void
}

const DurationToggleButton = ({ durationType, setDurationType }: DurationToggleButtonProps) => {
    return (
        <div className='exposer__duration__toggle__container'>
            {['SEC', 'MIN'].map((type) => {
                const active = type === durationType ? 'active' : ''
                return (
                    <button
                        key={type}
                        onClick={() => { setDurationType(type as DurationType) }}
                        className={mergeClassNames('exposer__duration__toggle__button', active)}>
                        {type}
                    </button>
                )
            })}
        </div>
    )
}

export default DurationToggleButton